import React from 'react'

import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	},
	button: {
		textTransform: 'uppercase'
	}
}))

const Confirmation = (props) => {
	const classes = useStyles()

	let { title, isShown, setIsShown, confirm, confirmTitle, cancel, cancelTitle, children, message } = props

	const handleConfirm = () => {
		if (confirm && typeof confirm === 'function') confirm()

		setIsShown(false)
	}

	const handleCancel = () => {
		if (cancel && typeof cancel === 'function') cancel()

		setIsShown(false)
	}

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 24,
					textTransform: 'uppercase'
				}}>
				{title || 'Confirm'}
			</DialogTitle>
			<DialogContent>
				<div
					style={{
						marginBottom: 24
					}}>
					{children ? (
						children
					) : (
						<Typography variant="body2">{message || 'Do you want to confirm this action?'}</Typography>
					)}
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					onClick={() => handleConfirm()}
					color="secondary"
					className={classes.button}>
					{confirmTitle || 'Confirm'}
				</Button>
				<Button
					variant="outlined"
					onClick={() => handleCancel()}
					color="secondary"
					className={classes.button}>
					{cancelTitle || 'Cancel'}
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default Confirmation
